import { DQ_PRICING_TAB } from './pricing-display-static-dq.config';
import { RESTFUL_APIS_TAB } from './pricing-display-static-rest.config';
import { STATIC_PRICING_MISC_TABS } from './pricing-display-static-misc.config';
import { StaticPricingTab } from './pricing-display-static.types';
import { DATA_ENHANCEMENT_SERVICES_TAB } from './pricing-display-static-des.config';
import { TOOLKIT_ON_PREMISE_TAB } from './pricing-display-static-toolkit.config';
import { PROFESSIONAL_SERVICES_TAB } from './pricing-display-static-psg.config';

export const STATIC_TAB_ORDER: string[] = [
  'desktop',
  'dq',
  'data-enhancement-services',
  'accuzip6-full-service-limited',
  'toolkit-on-premise',
  'restful-apis',
  'professional-services',
  'living-mail',
  'list-pricing',
  'variable-maps',
  'konica',
];

export const STATIC_PRICING_TABS: StaticPricingTab[] = [
  DQ_PRICING_TAB,
  DATA_ENHANCEMENT_SERVICES_TAB,
  RESTFUL_APIS_TAB,
  TOOLKIT_ON_PREMISE_TAB,
  PROFESSIONAL_SERVICES_TAB,
  ...STATIC_PRICING_MISC_TABS,
];

export const STATIC_PRICING_TAB_BY_ID = new Map(
  STATIC_PRICING_TABS.map((tab) => [tab.id, tab])
);
